interface MilestoneLike {
  readonly key: string;
  readonly label: string;
  readonly state: "complete" | "active" | "pending";
}

/** Shared segmented, state-derived progress bar — one real milestone per segment, never a fabricated percentage. Used by both Gate 1 and Gate 2 progress cards. */
export function MilestoneStrip({ milestones, stuck }: { readonly milestones: readonly MilestoneLike[]; readonly stuck: boolean }) {
  return (
    <div className="progress-segments" aria-label={milestones.map((m) => m.label).join(" -> ")}>
      {milestones.map((m) => (
        <div key={m.key} className={`progress-segment ${m.state === "active" && stuck ? "stuck" : m.state}`} title={m.label} />
      ))}
    </div>
  );
}
